import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CartModel } from '../models/cart-product-model';

@Injectable({
  providedIn: 'root',
})
export class CartService {
  items: CartModel[] = [];
  constructor(private http: HttpClient) {
    this.items = JSON.parse(localStorage.getItem('cart')) || [];
  }

  addToCart(product: CartModel) {
    if (this.items.some(item => item.product.id === product.product.id)) {
      this.items = this.items.map(item => {
        if (item.product.id === product.product.id) {
          return { ...item, amount: item.amount + product.amount };
        }
        return item;
      });
    } else {
      this.items.push(product);
    }
    localStorage.setItem('cart', JSON.stringify(this.items));
  }

  changeAmount(product: CartModel) {
    this.items = this.items.map(item => {
      if (item.product.id === product.product.id) {
        return { ...item, amount: product.amount };
      }
      return item;
    });
    localStorage.setItem('cart', JSON.stringify(this.items));
  }

  getItems() {
    return this.items;
  }

  getItemsCount() {
    return this.items.reduce((acc, item) => acc + item.amount, 0);
  }

  removeItem(item: CartModel) {
    this.items = this.items.filter(cartItem => cartItem !== item);
    localStorage.setItem('cart', JSON.stringify(this.items));
  }

  clearCart() {
    this.items = [];
    localStorage.setItem('cart', JSON.stringify(this.items));
  }

  getTotalAmount() {
    return this.items.reduce(
      (acc, item) => acc + item.amount * item.product.payedAmount,
      0
    );
  }

  updateCart(items: CartModel[]) {
    this.items = items;
    localStorage.setItem('cart', JSON.stringify(this.items));
  }
}
